/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsDashboardCtrl
 * @description General overview report with the most important report data
 */
angular.module('mercury.modules.reports.dashboard')
.controller('ReportsDashboardCtrl', ["Budgets", "$q", "$scope", "ReportItemCategories", "ReportSales", "ReportOrders", "reporttime", "$stateParams", "$filter", "title", function(Budgets, $q, $scope, ReportItemCategories, ReportSales, ReportOrders, reporttime, $stateParams, $filter, title) {
  title.set('Dashboard');

  $scope.now = moment(reporttime.time()).format();

  var salesByDay = {};
  var budgetsByDay = {};

  var startMoment = moment.min(
    moment(reporttime.time()).mStartOf('month'),
    moment(reporttime.time()).mStartOf('week')
  );

  var endMoment = moment.max(
    moment(reporttime.time()).mStartOf('month').add(1, 'month'),
    moment(reporttime.time()).mStartOf('week').add(1, 'week')
  );

  var recentOrdersStart = moment(reporttime.time()).mStartOf('halfhour').add(30, 'minutes').subtract(12, 'hours').format();
  var recentOrdersEnd = moment(reporttime.time()).mStartOf('halfhour').add(30, 'minutes').format();

  var dayOrdersStart = moment(reporttime.time()).mStartOf('day');
  var dayOrdersEnd = moment(reporttime.time()).mEndOf('day');

  // Gather required data
  $scope.loading = $q.all({
    budgets: Budgets.getAll(startMoment.format(), endMoment.format()),
    sales: ReportSales.getByDay(startMoment.format(), endMoment.format()),
    orders: ReportOrders.getByDay(dayOrdersStart.format(), dayOrdersEnd.format()),
    recentOrders: ReportOrders.getByHalfHour(recentOrdersStart, recentOrdersEnd),
    itemCategories: ReportItemCategories.getOrders(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(result) {
    $scope.recentOrders = result.recentOrders;

    $scope.itemCategory = $filter('orderBy')(result.itemCategories, 'label');

    angular.forEach(result.budgets, function(val) {
      var idx = moment(val.date).mStartOf('day').format();
      budgetsByDay[idx] = val.amount;
    });

    angular.forEach(result.sales, function(period) {
      var idx = moment(period.startTime).format();
      salesByDay[idx] = period;
    });

    $scope.nettSalesTotal = salesByDay[reporttime.start()].invoices;
    $scope.grossSalesTotal = result.orders[0].amount;
    $scope.discountsTotal = salesByDay[reporttime.start()].discounts;
    $scope.budget = budgetsByDay[reporttime.start()] || 0;

    $scope.weekSaleBudgets = [];

    for (
      var iterator = moment(reporttime.time()).mStartOf('week');
      iterator.isBefore(moment(reporttime.time()).mStartOf('week').add(1, 'week'));
      iterator.add(1, 'day')
    ) {
      var salesAmount = salesByDay[iterator.format()].invoices;
      var budgetAmount = budgetsByDay[iterator.format()] || 0;

      $scope.weekSaleBudgets.push({
        day: iterator.format(),
        sales: salesAmount,
        budget: budgetAmount,
        difference: salesAmount - budgetAmount
      });
    }

    $scope.monthSalesGraphData = [];
    var accumulativeSales = 0;
    var accumulativeBudgets = 0;
    for (
      var monthIterator = moment(reporttime.time()).mStartOf('month');
      monthIterator.isBefore(moment(reporttime.time()).mStartOf('month').add(1, 'month'));
      monthIterator.add(1, 'day')
    ) {
      accumulativeSales += salesByDay[monthIterator.format()].invoices;
      accumulativeBudgets += budgetsByDay[monthIterator.format()] || 0;

      $scope.monthSalesGraphData.push({
        time: monthIterator.format('ddd Do'),
        sales: accumulativeSales,
        budget: accumulativeBudgets
      });
    }
  });

  // Column definition for 'Recent Gross Sales' graph
  $scope.recentOrdersGraphCols = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Orders', type: 'number', key: 'amount', filter: 'currency'}
  ];

  // Column definitions for 'Item Categories' graph
  $scope.itemCatGraphCols = [
    {label: 'Category', type: 'string', key: 'label'},
    {label: 'Orders', type: 'number', key: 'amount', filter: 'currency'}
  ];

  // Column definitions for the 'This Months Sales' graph
  $scope.monthGraphCols = [
    {label: 'Date', type: 'string', key: 'time'},
    {label: 'Sales', type: 'number', filter: 'currency', key: 'sales'},
    {label: 'Budget', type: 'number', filter: 'currency', key: 'budget'}
  ];
}]);
